import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config/index.js';
import { Constant } from '../../../../../Containers/Helpers/constant.js';
import { CREATE_TEMPLATE_WORKFLOW, CREATE_TEMPLATE_WORKFLOW_ERROR, CREATE_TEMPLATE_WORKFLOW_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* createTemplateWorkflow({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v2/admin/create-surge-workflow`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CREATE_TEMPLATE_WORKFLOW_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_TEMPLATE_WORKFLOW_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_TEMPLATE_WORKFLOW_ERROR, payload: error });
  }
}

export function* watchCreateTemplateWorkflow() {
  yield takeEvery(CREATE_TEMPLATE_WORKFLOW, createTemplateWorkflow);
}

function* createTemplateWorkflowSaga() {
  yield all([fork(watchCreateTemplateWorkflow)]);
}

export default createTemplateWorkflowSaga;
